<template>
  <aside id="sidebar-left" class="sidebar-left">
    <div class="sidebar-header">
      <div class="sidebar-title">
        Navigation
      </div>
      <!--<div class="sidebar-toggle hidden-xs" data-toggle-class="sidebar-left-collapsed" data-target="html" data-fire-event="sidebar-left-toggle">
        <em class="fa fa-bars" aria-label="Toggle sidebar"></em>
      </div>-->
    </div>

    <div class="nano">
          <ul class="nav nav-main">
            <li class="nav-active">
              <router-link class="nav-link" :to="{name:'tableaudebord'}"><em class="fa fa-home" aria-hidden="true"></em>&nbsp;&nbsp;<span>Accueil</span></router-link>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#submenu1"  data-target="#submenu1" ><em class="fa fa-file" aria-hidden="true"></em>&nbsp;&nbsp;Zone A</a>
              <div  id="submenu1" aria-expanded="false">
                <ul class="flex-column pl-2 nav nav-main children">
                    <li class="nav-item"><router-link class="nav-link" :to="{name:'liste_billets'}"><em class="fab fa-stack-overflow fa-fw fa-spacer"></em>Billets</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" :to="{name:'liste_fournisseurs'}"><em class="fa fa-list-ul fa-fw fa-spacer" aria-hidden="true"></em>Fournisseurs</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" :to="{name:'liste_dossiers'}"><em class="fa fa-archive fa-fw fa-spacer" aria-hidden="true"></em>Dossiers</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/export"><em class="fa fa-file-export fa-fw fa-spacer" aria-hidden="true"></em>Export</router-link></li>
                    <li v-if="isAdminOrSuperAdmin" class="nav-item"><router-link class="nav-link" :to="{name:'admin'}"><em class="fas fa-wrench fa-fw fa-spacer" aria-hidden="true"></em>Administration</router-link></li>
                </ul>
              </div>
            </li>

            <li class="nav-item">
              <router-link class="nav-link" to="/rapports"><em class="fa fa-list-ul" aria-hidden="true"></em>&nbsp;&nbsp;Rapports SEF</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/ressources"><em class="fa fa-question-circle" aria-hidden="true"></em>&nbsp;&nbsp;Ressources</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/nous-joindre"><em class="fa fa-envelope" aria-hidden="true"></em>&nbsp;&nbsp;Nous joindre</router-link>
            </li>
          </ul>
      </div>
  </aside>
</template>

<style>

ul.children li em {margin-left:15px;}

.nano,.sidebar-left {

    background: #1d2127 !important;
    -webkit-box-shadow: -5px 0 0 #2f3139 inset !important;
    box-shadow: inset -5px 0 0 #2f3139 !important;
    display:block;
    position:relative;
}

</style>

<script>
import {privileges} from '@/mixins/privileges.js';

export default {
  name: 'TheSideBar',
  mixins: [privileges]
}
</script>
